export const CARD_IMG_HEIGHT = 148;
export const CARD_IMG_HEIGHT_XS = 121;
export const CARD_MIN_HEIGHT = 274;
export const CARD_MIN_HEIGHT_XS = 232;
export const CARD_WIDTH_XS = 240;
export const CARD_GAP_XS = 11;
export const CARD_MARGIN = 11;
export const CARD_WIDTH = 278;
